<app-toast></app-toast>

<div class="grid grid-cols-2 h-screen w-full mobile:flex">

    <div class="bg-primary-800 flex flex-col gap-5 mobile:hidden">
        <div class="flex self-center mt-[15%] mx-5">
            <div class="text-white max-w-[550px]">
                <h1 class="text-[38px] font-bold">{{ 'auth.welcome_to' | transloco }}</h1>
                <pre class="text-[16px] leading-6 whitespace-pre-line">{{ 'auth.platform_desc' | transloco }}</pre>

                <div class="flex items-center rounded-md w-[50px] h-1 gap-1 mt-5">
                    <div class="bg-white rounded-full h-1 w-3/4"></div>

                    <div class="flex items-center gap-1">
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-grow flex justify-end items-end">
            <img src="assets/images/signup-page/dashboard-example.png"
                alt="{{ 'auth.dashboard_example_image' | transloco }}"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
    </div>

    <div class="bg-white p-4 z-40 px-20 flex flex-col h-full mobile:px-7 mobile:w-screen">
        <app-logo class="self-start mobile:self-center mobile:mt-10"></app-logo>
        <div class="flex-grow flex flex-col justify-center items-center">
            <h1 class="text-5xl font-bold self-start mobile:text-xl mobile:mt-[10vh]">{{ 'auth.sign_up_to_create' |
                transloco }}</h1>
            <p class="mt-1 self-start mobile:text-base">{{ 'auth.join_and_start_optimizing' | transloco }}</p>

            <form [formGroup]="emailForm" (ngSubmit)="continueClick()" class="max-w-screen-sm w-full">
                <div class="w-full self-center mt-[5vh] mobile:mt-5">
                    <app-labeled-input labelText="{{ 'auth.email_address' | transloco }}"
                        [iconSrc]="'assets/icons/sms.svg'" iconAltText="{{ 'auth.sms_icon' | transloco }}"
                        [inputId]="'email'" [inputType]="'email'" [(inputValue)]="emailForm.controls['email'].value"
                        [errorMessage]="inputError" [isDisabled]="continueClicked" autocomplete="email"></app-labeled-input>
                </div>

                <div class="w-full mt-8">
                    <app-primary-button buttonText="{{ 'shared.continue' | transloco }}" [isDisabled]="continueClicked">
                    </app-primary-button>
                </div>
            </form>

            <div class="max-w-screen-sm w-full my-4">
                <app-separator-with-text></app-separator-with-text>
            </div>


            <div class="max-w-screen-sm w-full self-center">
                <app-social-sign-in-button buttonText="{{ 'auth.google_sign_in' | transloco }}"
                    [iconSrc]="'assets/icons/LogoGoogle.svg'"
                    iconAltText="{{ 'shared.icon' | transloco }}" (buttonClick)="googleLoginButtonClick()"></app-social-sign-in-button>
            </div>

            <div class="max-w-screen-sm w-full self-center mt-2">
                <app-social-sign-in-button buttonText="{{ 'auth.linkedin_sign_in' | transloco }}"
                    [iconSrc]="'assets/icons/Logolinkedin.svg'"
                    iconAltText="{{ 'shared.icon' | transloco }}" (buttonClick)="linkedinLoginButtonClick()"></app-social-sign-in-button>
            </div>



        </div>
    </div>


</div>